// extracted by mini-css-extract-plugin
module.exports = {"cont-offer":"cont-offer","contOffer":"cont-offer","container":"container"};